var _defs, _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 24,
    fill: "none",
    viewBox: "0 0 34 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.7,
    height: 23.7,
    x: 0.15,
    y: 0.15,
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeWidth: 0.3,
    rx: 2.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F72CD",
    fillRule: "evenodd",
    d: "M5.883 8.454l-3.257 7.208h3.899l.483-1.15h1.105l.484 1.15h4.291v-.878l.383.878h2.22l.382-.896v.896H24.8l1.085-1.12 1.016 1.12 4.585.009-3.268-3.593 3.268-3.624H26.97l-1.056 1.099-.985-1.099h-9.71l-.833 1.86-.853-1.86H9.643v.847l-.433-.847H5.883zm.754 1.023h1.9l2.161 4.888V9.477h2.082l1.669 3.505 1.538-3.505h2.071v5.172h-1.26l-.01-4.052-1.838 4.052h-1.128l-1.848-4.052v4.052H9.381l-.492-1.16H6.233l-.49 1.16h-1.39l2.284-5.172zm17.7 0H19.21v5.17h5.047l1.626-1.714 1.568 1.713h1.638l-2.381-2.57 2.381-2.599h-1.567l-1.619 1.694-1.567-1.694zm-16.775.875l-.875 2.066h1.749l-.874-2.066zm12.915 1.14v-.944h3.198l1.396 1.51-1.458 1.517h-3.136v-1.03h2.796v-1.053h-2.796z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.1e27bab8.svg";
export { ForwardRef as ReactComponent };